import React, { useState } from 'react'
import { Link, navigate } from 'gatsby'

const MobilePosts = ({
    yearsAvailable,
    sortedArtists,
    sortedCategories,
    sortedTopics,
    yearsToShow,
    artistsToShow,
    categoriesToShow,
    topicsToShow,
    handleYearChange,
    handleArtistChange,
    handleCategoryChange,
    handleTopicChange,
    posts,
    filterPosts,
    isFiltering,
    clearFilters
  }) => {

  const [filtersVisible, setFiltersVisible] = useState(false)
  const [yearOptionsVisible, setYearOptionsVisible] = useState(false)
  const [artistOptionsVisible, setArtistOptionsVisible] = useState(false)
  const [categoryOptionsVisible, setCategoryOptionsVisible] = useState(false)
  const [topicOptionsVisible, setTopicOptionsVisible] = useState(false)

  const toggleFilters = () => {
    setFiltersVisible(prev => !prev)
    setYearOptionsVisible(prev => {
      if (prev === false) {
        return prev
      } else {
        return true
      }
    })
    setArtistOptionsVisible(prev => {
      if (prev === false) {
        return prev
      } else {
        return true
      }
    })
    setCategoryOptionsVisible(prev => {
      if (prev === false) {
        return prev
      } else {
        return true
      }
    })
    setTopicOptionsVisible(prev => {
      if (prev === false) {
        return prev
      } else {
        return true
      }
    })
  }

  const toggleYearOptions = () => {
    setYearOptionsVisible(prev => !prev)
  }

  const toggleArtistOptions = () => {
    setArtistOptionsVisible(prev => !prev)
  }

  const toggleCategoryOptions = () => {
    setCategoryOptionsVisible(prev => !prev)
  }

  const toggleTopicOptions = () => {
    setTopicOptionsVisible(prev => !prev)
  }

  const handleYearOptionChange = (year) => {
    const selectedYear = Number(year)
    handleYearChange(selectedYear)
    setYearOptionsVisible(prev => {
      if (prev === true) {
        return prev
      } else {
        return false
      }
    })
    setFiltersVisible(prev => !prev)
  }

  const handleArtistOptionChange = (artist) => {
    handleArtistChange(artist)
    setArtistOptionsVisible(prev => {
      if (prev === true) {
        return true
      } else {
        return false
      }
    })
    setFiltersVisible(prev => !prev)
  }

  const handleCategoryOptionChange = (category) => {
    handleCategoryChange(category)
    setCategoryOptionsVisible(prev => {
      if (prev === true) {
        return true
      } else {
        return false
      }
    })
    setFiltersVisible(prev => !prev)
  }

  const handleTopicOptionChange = (topic) => {
    handleTopicChange(topic)
    setTopicOptionsVisible(prev => {
      if (prev === true) {
        return prev
      } else {
        return false
      }
    })
    setFiltersVisible(prev => !prev)
  }

  const filteredMobilePosts = posts.filter(({ node: post }) => filterPosts(post))

    return (
      <>
        <div className='mobile-filters'>

        <button className='mobile-filters__toggle' onClick={toggleFilters}>
          Filters
        </button>

        {/* Clear filters button */}
        {isFiltering &&
          <button className='mobile-filters__clear' onClick={clearFilters}>Clear filters</button>
        }

        {filtersVisible && (
          <div className='mobile-filters__options'>
            <div className='mobile-filters__category'>
              <div
                className='mobile-filters__category-title'
                onClick={toggleYearOptions}
              >
                Year
              </div>
              {yearOptionsVisible && (
                <div className='mobile-filters__category-options'>
                  {yearsAvailable.map((year) => (
                    <div className='mobile-filters__option' key={year}>
                      <input
                        type='checkbox'
                        name='year'
                        id={`year-${year}`}
                        value={year}
                        checked={yearsToShow.includes(year)}
                        onChange={() => handleYearOptionChange(year)}
                      />
                      <label htmlFor={`year-${year}`}>{year}</label>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className='mobile-filters__category'>
              <div
                className='mobile-filters__category-title'
                onClick={toggleArtistOptions}
              >
                Artist/Entity
              </div>
              {artistOptionsVisible && (
                <div className='mobile-filters__category-options'>
                  {sortedArtists.map((artist) => (
                    <div className='mobile-filters__option' key={artist}>
                      <input
                        type='checkbox'
                        name='artist'
                        id={`artist-${artist}`}
                        value={artist}
                        checked={artistsToShow.includes(artist)}
                        onChange={() => handleArtistOptionChange(artist)}
                      />
                      <label htmlFor={`artist-${artist}`}>{artist}</label>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className='mobile-filters__category'>
              <div
                className='mobile-filters__category-title'
                onClick={toggleCategoryOptions}
              >
                Category
              </div>
              {categoryOptionsVisible && (
                <div className='mobile-filters__category-options'>
                  {sortedCategories.map((category) => (
                    <div className='mobile-filters__option' key={category}>
                      <input
                        type='checkbox'
                        name='category'
                        id={`category-${category}`}
                        value={category}
                        checked={categoriesToShow.includes(category)}
                        onChange={() => handleCategoryOptionChange(category)}
                      />
                      <label htmlFor={`category-${category}`}>{category}</label>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className='mobile-filters__category'>
              <div
                className='mobile-filters__category-title'
                onClick={toggleTopicOptions}
              >
                Topic
              </div>
              {topicOptionsVisible && (
                <div className='mobile-filters__category-options'>
                  {sortedTopics.map((topic) => (
                    <div className='mobile-filters__option' key={topic}>
                      <input
                        type='checkbox'
                        name='topic'
                        id={`topic-${topic}`}
                        value={topic}
                        checked={topicsToShow.includes(topic)}
                        onChange={() => handleTopicOptionChange(topic)}
                      />
                      <label htmlFor={`topic-${topic}`}>{topic}</label>
                    </div>
                  ))}
                </div>
              )}
            </div>

          </div>
        )}
        </div>

        <div className='project--list_mobile'>
              { filteredMobilePosts.length > 0 ? 
                filteredMobilePosts.map(({ node: post }) => (
                  <div
                    key={post.id}
                    onClick={() => {
                      const newPath = post.fields.slug
                      navigate(newPath)
                    }}
                    onKeyUp={() => {
                      const newPath = post.fields.slug
                      navigate(newPath)
                    }}
                    role='presentation'
                  >
                    <p>
                      <Link
                        className='card--title'
                        to={post.fields.slug}
                      >
                        {post.frontmatter.title} ({post.frontmatter.yearcreated})
                      </Link>
                    </p>
                  </div>
                )) : (
                  <div>
                    <p>Sorry, no posts match the selected filters</p>
                  </div>
                )
              }
        </div>
      </>
    )
}

export default MobilePosts